var map = {
	"./insta-1.jpg": "b8fb",
	"./insta-2.jpg": "d019",
	"./insta-3.jpg": "6bce",
	"./insta-4.jpg": "2c0e",
	"./insta-5.jpg": "5d0c",
	"./insta-6.jpg": "f5d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f2c";